import { toSeconds } from '@art-suite/art-core-ts';

const DEFAULT_DELTA_FETCH_DISABLE_DURATION_SECONDS = 10;

/**
 * Global timestamp (in seconds) until which delta fetches are disabled.
 * Any fetch before this time will be a full fetch instead of a delta.
 * Initialized to 10 seconds after module load so app restarts trigger full fetches.
 */
let deltaFetchDisabledUntil = toSeconds() + DEFAULT_DELTA_FETCH_DISABLE_DURATION_SECONDS;

/**
 * Temporarily disable delta fetches for the given number of seconds.
 * During this window, all scan data fetches will be full fetches instead of deltas.
 * Use this before triggering a refresh to ensure a full re-sync.
 *
 * @param seconds - Number of seconds to disable delta fetches for
 */
export const disableDeltaFetchesTemporarily = (seconds: number = DEFAULT_DELTA_FETCH_DISABLE_DURATION_SECONDS): void => {
  deltaFetchDisabledUntil = toSeconds() + seconds;
};

/**
 * Returns true if delta fetches are currently disabled (i.e., we're within a full-fetch window).
 */
export const deltaFetchesDisabled = (): boolean => toSeconds() < deltaFetchDisabledUntil;

export const deltaFetchesEnabled = (): boolean => !deltaFetchesDisabled();

/** Exposed for testing only. */
export const _resetDeltaFetchGate = (): void => {
  deltaFetchDisabledUntil = 0;
};
